import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { KIOSK_ORDER_STATUS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { KioskOrderStatusBlockScenarioContent } from '@front-platform/content-builder';

import {
  KIOSK_ORDER_STATUS_BLOCK_LOADING_VM,
  KioskOrderStatusBlockDataSource,
  KioskOrderStatusBlockViewModel,
} from './kiosk-order-status-block-view-model';

@Injectable()
export class KioskOrderStatusBlockPreviewDataSource implements KioskOrderStatusBlockDataSource {
  readonly vm$: Observable<KioskOrderStatusBlockViewModel> = previewScenarioForBloc$(
    KIOSK_ORDER_STATUS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return KIOSK_ORDER_STATUS_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<KioskOrderStatusBlockScenarioContent>(
        scenario,
        KIOSK_ORDER_STATUS_BLOCK_COMPONENT,
      ) as KioskOrderStatusBlockViewModel | null;
      return content ?? KIOSK_ORDER_STATUS_BLOCK_LOADING_VM;
    }),
  );
}
